export default __webpack_public_path__ + "static/media/email.5df8725b.png";